
import { motion } from 'framer-motion';

export default function EcommerceIntegration() {
  const platforms = [
    {
      name: 'Amazon',
      logo: 'ri-amazon-line',
      hmuRange: '5-200 HMUs',
      actions: 'View • Wishlist • Purchase • Review',
      image: 'https://public.readdy.ai/ai/img_res/a571e47dda17750d080f896982b5482d.jpg',
      bgColor: 'bg-gradient-to-br from-orange-50 to-orange-100',
    },
    {
      name: 'Temu',
      logo: 'ri-shopping-cart-line',
      hmuRange: '10-250 HMUs',
      actions: 'Browse • Add to Cart • Purchase • Share',
      image: 'https://readdy.ai/api/search-image?query=vibrant%20colorful%20online%20shopping%20interface%20with%20diverse%20products%2C%20modern%20e-commerce%20platform%20on%20mobile%20device%2C%20bright%20cheerful%20lighting%2C%20young%20person%20discovering%20deals%20and%20bargains%2C%20simple%20clean%20background%20with%20product%20variety&width=600&height=400&seq=temu-shop-001&orientation=landscape',
      bgColor: 'bg-gradient-to-br from-red-50 to-pink-100',
    },
    {
      name: 'TikTok Shop',
      logo: 'ri-tiktok-line',
      hmuRange: '15-300 HMUs',
      actions: 'Watch • Like • Purchase • Create Content',
      image: 'https://readdy.ai/api/search-image?query=trendy%20social%20commerce%20shopping%20on%20smartphone%2C%20tiktok%20style%20product%20discovery%20with%20engaging%20content%2C%20modern%20lifestyle%20photography%20with%20soft%20lighting%2C%20person%20enjoying%20mobile%20shopping%20experience%2C%20minimalist%20contemporary%20setting&width=600&height=400&seq=tiktok-shop-001&orientation=landscape',
      bgColor: 'bg-gradient-to-br from-cyan-50 to-blue-100',
    },
  ];

  return (
    <section id="shop" className="py-24 bg-gradient-to-b from-white to-honey-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="grid lg:grid-cols-2 gap-12 mb-16">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <div className="text-sm font-light text-gray-500 tracking-wide mb-3">SHOP & EARN</div>
            <h2 className="text-5xl font-bold text-charcoal-800 leading-tight">
              Your Favorite Stores, <span className="text-honey-600">Extra Rewards</span>
            </h2>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="flex items-center"
          >
            <p className="text-gray-600 leading-relaxed">
              Connect your favorite e-commerce platforms and earn HMUs on every interaction. From browsing to purchasing, every action rewards you with points you can redeem for exclusive merchandise and digital products.
            </p>
          </motion.div>
        </div>

        {/* Platform Cards */}
        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {platforms.map((platform, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.15 }}
              whileHover={{ y: -8 }}
              className="group cursor-pointer"
            >
              <div className="bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all">
                {/* Image */}
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={platform.image}
                    alt={platform.name}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
                  
                  {/* HMU Badge */}
                  <div className="absolute bottom-4 left-4 bg-honey-500 text-white px-4 py-2 rounded-full text-sm font-semibold shadow-lg">
                    {platform.hmuRange}
                  </div>
                </div>

                {/* Content */}
                <div className="p-6">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-12 h-12 flex items-center justify-center bg-charcoal-800 rounded-xl">
                      <i className={`${platform.logo} text-2xl text-white`}></i>
                    </div>
                    <h3 className="text-2xl font-bold text-charcoal-800">{platform.name}</h3>
                  </div>
                  <p className="text-gray-600 text-sm mb-4">{platform.actions}</p>
                  <button className="w-full py-3 bg-charcoal-800 text-white rounded-xl font-semibold hover:bg-charcoal-700 transition-all whitespace-nowrap">
                    Connect Now
                  </button>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Bottom CTA Bar */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="bg-gradient-to-r from-honey-500 to-honey-600 rounded-2xl p-8 text-center shadow-xl"
        >
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="text-white">
              <h3 className="text-2xl font-bold mb-2">Connect 5+ platforms and earn bonus 500 HMUs</h3>
              <p className="text-white/90">Limited time offer for new users</p>
            </div>
            <button className="px-8 py-4 bg-white text-honey-600 rounded-xl font-bold text-lg hover:scale-105 transition-all shadow-lg whitespace-nowrap">
              Get Started <i className="ri-arrow-right-line ml-2"></i>
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
